import React, { FC } from 'react'
import { ListItem, ListItemProps } from '@mui/material'

export const EvtListItem: FC<ListItemProps> = ({ children, ...props }) => {
    return <ListItem {...props}>{children}</ListItem>
}

export default EvtListItem
